export default "__VITE_ASSET__19LrzlIS__"